
export const hasPermission = (userPermissionsData, group, resource) => {
    const re = new RegExp(`^${resource}`);
    return userPermissionsData[group] && userPermissionsData[group].some(resourceTmp => resourceTmp.match(re));
}
